import React from 'react';
import PageHeader from '../components/PageHeader';
import ActivitiesGrid from '../components/ActivitiesGrid';
import { useContent } from '../context/ContentContext';

const Activities = () => {
  const { content, loading } = useContent();
  const activitiesContent = content?.activities || { title: 'Atividades', description: 'Conheça nossas principais atividades e projetos.' };

  if (loading) {
    return (
      <main>
        <PageHeader title="Carregando..." description="Aguarde enquanto buscamos as atividades." />
      </main>
    );
  }

  return (
    <main>
      <PageHeader 
        title={activitiesContent.title} 
        description={activitiesContent.description}
      />
      
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <ActivitiesGrid detailed={true} />
        </div>
      </section>
    </main>
  );
};

export default Activities;
